module.exports = __webpack_public_path__ + "media/apps/gif-ios-34-8efbf5f4.gif";